import { icon } from 'leaflet';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [

  {
    id: 2,
    label: 'Dashboard',
    icon: 'ri-dashboard-2-line',
    link: '/'
  },

  {
    id: 4,
    label: 'Surveys',
    icon: 'ri-file-list-3-line',
    subItems: [
      {
        id: 3,
        label: 'Survey List',
        icon: 'ri-task-line',
        link: '/survey-list'
      },
      {
        id: 41,
        label: 'Zone Wise Summary',
        link: '/reports/zone-wise-summary',
        icon: 'ri-file-list-3-line',
        parentId: 4
      },
      {
        id: 42,
        label: 'Ward Wise Summary',
        link: '/reports/ward-wise-summary',
        icon: 'ri-file-list-3-line',
        parentId: 4
      },
      {
        id: 43,
        label: 'User Wise Summary',
        link: '/reports/user-wise-summary',
        icon: 'ri-file-list-3-line',
        parentId: 4
      }
    ]
  },

  // {
  //   id: 7,
  //   label: 'User Management',
  //   icon: 'ri-user-line',
  //   link: '/user'
  // },
  // {
  //   id: 4,
  //   label: 'Newly Registered',
  //   icon: 'ri-task-line',
  //   link: '/newly-registered-properties'
  // },
  {
    id: 7,
    label: 'Bill Distribution',
    icon: 'ri-file-list-3-line',
    subItems: [
      {
        id: 71,
        label: 'Bill Distribution List',
        link: '/bill-distribution-list',
        icon: 'ri-list-check',
        parentId: 7
      },
      {
        id: 72,
        label: 'Zone Wise Report',
        link: '/bill-distribution-report/zone-wise',
        icon: 'ri-map-2-line',
        parentId: 7
      },
      {
        id: 73,
        label: 'Ward Wise Report',
        link: '/bill-distribution-report/ward-wise',
        icon: 'ri-building-line',
        parentId: 7
      },
      {
        id: 74,
        label: 'User Wise Report',
        link: '/bill-distribution-report/user-wise',
        icon: 'ri-user-line',
        parentId: 7
      }
    ]
  },
  {
    id: 6,
    label: 'Self-Assessments',
    icon: 'ri-file-text-line',
    subItems: [
      {
        id: 61,
        label: 'All Self-Assessments',
        link: '/self-declarations',
        icon: 'ri-list-check',
        parentId: 6
      },
      {
        id: 62,
        label: 'Zone Wise Report',
        link: '/self-declarations/zone-wise-report',
        icon: 'ri-map-2-line',
        parentId: 6
      },
      {
        id: 63,
        label: 'Ward Wise Report',
        link: '/self-declarations/ward-wise-report',
        icon: 'ri-building-line',
        parentId: 6
      }
    ]
  },
  {
    id: 9,
    label: 'Correction Complaints',
    icon: 'ri-file-edit-line',
    subItems: [
      {
        id: 91,
        label: 'All Complaints',
        link: '/correction-complaints',
        icon: 'ri-list-check',
        parentId: 9
      },
      {
        id: 92,
        label: 'Pending Correction',
        link: '/correction-complaints/pending-correction',
        icon: 'ri-hourglass-line',
        parentId: 9
      },
      {
        id: 93,
        label: 'Zone Wise Report',
        link: '/correction-complaints/zone-wise-report',
        icon: 'ri-hourglass-line',
        parentId: 9
      },
      {
        id: 94,
        label: 'Ward Wise Report',
        link: '/correction-complaints/ward-wise-report',
        icon: 'ri-hourglass-line',
        parentId: 9
      }
    ]
  },
  {
    id: 8,
    label: 'Complaints',
    icon: 'ri-feedback-line',
    subItems: [
      {
        id: 71,
        label: 'Complaint List',
    link: '/complaint-list',
        icon: 'ri-list-check',
        parentId: 7
      },
      {
        id: 82,
        label: 'Zone Wise Complaint',
        link: '/complaint-list/zone-wise',
        icon: 'ri-map-2-line',
        parentId: 7
      },
      {
        id: 83,
        label: 'Ward Wise Complaint',
        link: '/complaint-list/ward-wise',
        icon: 'ri-building-line',
        parentId: 7
      },
    ]
  },
  // {
  //   id: 5,
  //   label: 'Property List',
  //   icon: 'ri-task-line',
  //   link: '/property-list'  
  // },

  

];
